import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
  },
  reserve: {
    display: "flex",
    flexDirection: "column",
    padding: "3rem",
  },
  titleReserve: {
    color: "#6E6E6E",
    marginBottom: "2rem",
    fontSize: "1.5rem",
    textAlign: "center",
  },
  inputReserve: {
    marginBottom: "2rem",
  },
  form: {
    width: "24rem",
  },
  errorMsg: {
    color: "red",
  },
  buttons: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop: "2rem",
  },
  dropReserveContainer: {
    display: "flex",
    justifyContent: "center",
  },
  dropReserve: {
    backgroundColor: "#DA5151",
    marginTop: "1rem",
    color: "#FFFFFF",
    "&.MuiButton-root:hover": {
      backgroundColor: "#DA5151",
      color: "#FFFFFF",
    },
  },
}))

export default useStyles
